import { CTI_STAFFING_BUSINESS_ENTITY_ID } from '@/lib/constants/businessEntities'

const createDealAssignment = () => ({
  // Negative ID flags this assignment as not yet persisted.
  // The real positive Id will be assigned by the backend after the first save.
  id: -(Math.floor(Math.random() * 1000000) + 1),
  dealId: null,
  dealCandidateId: null,
  employeeTypeId: null,
  corporateName: null,
  ein: null,
  payFrequencyId: null,
  contractTypeId: null,
  lengthOfContract: null,
  conversionFee: null,
  payRateTypeId: null,
  payRate: null,
  billRateTypeId: null,
  billRate: null,
  overtimeEligible: null,
  startAt: null,
  endAt: null,
  jobTitle: null,
  permPlacementDate: null,
  permPlacementSalary: null,
  permPlacementFee: null,
  permPlacementFeeTypeId: null,
  permPlacementNetFee: null,
  permPlacementInvoiceDate: null,
  permPlacementInvoiceDueDate: null,
  commissions: [],
  expenses: [],
  expensesDeduction: 0,
  expensesDeductionHint: null,
  workedHoursAverage: null,
  overtimeThreshold: null,
  overtimeRate: null,
  timeSheetType: 2,
  clockIPAddress: null,
  contractorCommissionEnabled: false,
  contractorCommissionMarkup: 0
})

const createDealClient = () => ({
  id: null,
  dealId: null,
  clientTypeId: null,
  dealClientId: null,
  existingClientId: null,
  businessEntityId: CTI_STAFFING_BUSINESS_ENTITY_ID,
  // This will be filled after the first automatic save
  // no need to worry about it here.
  businessEntityName: 'CTI Staffing',
  name: null,
  invoiceFrequencyId: null,
  thirdPartyPortalId: null,
  vmsFee: null,
  useStaffLynxForTimeEntering: false
})

const createDealProject = () => ({
  id: null,
  dealId: null,
  projectName: null
})

export const getEmptyDeal = () => ({
  id: null,
  statusId: null,
  createAt: null,
  createdBy: null,
  updatedAt: null,
  updatedBy: null,
  zrJobOpeningId: null,
  dealCreationTypeId: null,
  dealAssignmentType: null,
  validationErrors: null,

  client: createDealClient(),
  project: createDealProject(),
  candidates: [getEmptyDealCandidate()],
  rejectionNotes: null
})

export function getEmptyDealCandidate () {
  return {
    // Negative ID flags this candidate as frontend-only (not yet persisted).
    // The real positive Id will be assigned by the backend after the first save.
    id: -(Math.floor(Math.random() * 1000000) + 1),
    dealId: null,
    dealCandidateTypeId: null,
    existingUserId: null,
    firstName: null,
    lastName: null,
    emailAddress: null,
    dealAssignment: createDealAssignment()
  }
}
